import { combineReducers } from "redux";
import entitiesReducer from "./entities/entitiesCombiner";
import authorizeReducer from "./auth/auth";
export default combineReducers({
  entities: entitiesReducer,
  authorize: authorizeReducer,
});
